import React, { useEffect, useState } from "react";
import Sidebar from "../../components/Sidebar";
import Topbar from "../../components/Topbar";
import Loader from "../../components/Loader";
import RequestAccess from "../../components/requestAccess/RequestAccess";
import { getModuleAccessInfoApi } from "../../api/candidate";
import Utils from "../../utils/Utils";
import WebUtils from "../../utils/WebUtils";

// import InSightMain from "../../insight/InSightMain";
import InSightMain from "../../components/insight/InSightMain";
import { ROLES } from "../../constants/UserRoles";
import OrgAdminJobsMain from "../../components/orgAdmin/jobsInsight/OrgAdminJobsMain";

const userDetail = Utils.getUserDetail();

function OrgAdminJobs() {
  const [loading, setLoading] = useState(false);
  const [moduleInfo, setModuleInfo] = useState();

  const getModuleInfo = async () => {
    const url = `${getModuleAccessInfoApi}?userIdentifier=${
      userDetail?.userIdentifier || null
    }`;

    setLoading(true);

    WebUtils.httpOperations(url, {}, "GET")
      .then((result) => {
        setLoading(false);
        if (
          result.data.resultStatusInfo.resultCode.toLowerCase() === "success"
        ) {
          setModuleInfo(result.data.data);
        }
      })
      .catch((err) => {
        setLoading(false);
        console.log(err);
      });
  };
  // useEffect(() => {
  //   getModuleInfo();
  // }, []);

  return (
    <>
      {loading && <Loader />}
      <div className="hirePlusPlusPageContent">
        <Sidebar activePage="jobs" userRole={ROLES.org_admin} />
        <div className="w-full hireplusplusRightContent">
          <Topbar
            activePage="jobs"
            userRole={ROLES.org_admin}
            newTitle="Jobs Insight"
            noNavigate={true}
          />

          <OrgAdminJobsMain />
        </div>
      </div>
    </>
  );
}

export default OrgAdminJobs;
